import React from "react";

export function createContext<T>() {
    return React.createContext<T>(null as never);
}
